import styled from 'styled-components'
import { CodeBlock as RawCodeBlock, Line } from '../../components'

export const CodeBlock = styled(RawCodeBlock)`
  ${Line} {
    /* This does not work on Safari. On Safari, will look like display flex; */
    display: ruby;
  }
`
